/** Inatividade com o separador visível: terminar sessão (máx. 10 min). */
export const IDLE_TIMEOUT_MS = 10 * 60 * 1000;

/** Separador em segundo plano mais de este tempo → ao voltar, exige novo login. */
export const BACKGROUND_RELOGIN_MS = 60 * 60 * 1000; // 1 hora

/** Limite máximo de sessão contínua (mesmo com actividade) — reforço de segurança. */
export const ABSOLUTE_SESSION_MAX_MS = 8 * 60 * 60 * 1000; // 8 horas

/** Evita gravar a actividade centenas de vezes por segundo. */
export const ACTIVITY_THROTTLE_MS = 1000;

/** De quanto em quanto tempo se verifica a inatividade (pela hora real, não por temporizador). */
export const IDLE_CHECK_MS = 15 * 1000;

/** Sinal de vida enquanto o painel está aberto. */
export const HEARTBEAT_MS = 30 * 1000;

/**
 * Painel fechado mais do que isto e depois reaberto (ex.: o Chrome reabre os
 * separadores ao arrancar e repõe o sessionStorage): pede login. Um F5 leva segundos.
 */
export const RESUME_GRACE_MS = 2 * 60 * 1000;

export const SESSION_START_KEY = "ieadhb_auth_session_start";

/** Última actividade (localStorage: partilhada pelos separadores do painel). */
export const LAST_ACTIVITY_KEY = "ieadhb_auth_last_activity";

/** Último sinal de vida do painel aberto (localStorage). */
export const HEARTBEAT_KEY = "ieadhb_auth_heartbeat";

/** Motivo do fim da sessão, mostrado na página de login (sessionStorage). */
export const LOGOUT_REASON_KEY = "ieadhb_auth_logout_reason";

/** Sincroniza logout entre separadores (localStorage). */
export const LOGOUT_BROADCAST_KEY = "ieadhb_auth_logout_ts";

/** Hora gravada (ms) ou null. */
export function readTimestamp(key) {
  try {
    const n = parseInt(localStorage.getItem(key) || "", 10);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function writeTimestamp(key, value = Date.now()) {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* ignore */
  }
}

export function clearSessionClock() {
  try {
    localStorage.removeItem(LAST_ACTIVITY_KEY);
    localStorage.removeItem(HEARTBEAT_KEY);
  } catch {
    /* ignore */
  }
}
